export interface ElementObject {
  dataType: string
  title: string
  value: string
  multiValue: boolean
  ':type': string
}

export interface ElementBooleanObject {
  dataType: string
  title: string
  value: boolean
  multiValue: boolean
  ':type': string
}

export interface ElementArrayObject {
  dataType: string
  title: string
  value: string[]
  multiValue: boolean
  ':type': string[]
}

export interface Elements {
  contentFragmentId?: ElementObject
  image?: ElementObject
  altImage?: ElementObject
  bulletIcon?: ElementObject
  bulletIcons?: ElementArrayObject
  bulletIconAltText?: ElementObject
  bulletIconAltTexts?: ElementArrayObject
  bulletPoints?: ElementArrayObject
  contentBadgeColor?: ElementObject
  contentBadgeText?: ElementObject
  eyebrowIcon?: ElementObject
  eyebrowIconAltText?: ElementObject
  eyebrow?: ElementObject
  heading?: ElementObject
  headingIcon?: ElementObject
  headingIconAltText?: ElementObject
  headingUnit?: ElementObject
  additionalNote?: ElementObject
  description?: ElementObject
  planName?: ElementObject
  price?: ElementObject
  scratchPrice?: ElementObject
  term?: ElementObject
  discount?: ElementObject
  buttonTextPrimary?: ElementObject
  buttonLinkPrimary?: ElementObject
  buttonLinkTypePrimary?: ElementObject
  buttonLinkNewTabPrimary?: ElementBooleanObject
  linkTypeButtonPrimary?: ElementObject
  linkIdButtonPrimary?: ElementObject
  buttonTextSecondary?: ElementObject
  buttonLinkSecondary?: ElementObject
  buttonLinkNewTabSecondary?: ElementBooleanObject
  buttonLinkTypeSecondary?: ElementObject
  linkIdButtonSecondary?: ElementObject
  linkTypeButtonSecondary?: ElementObject
  buttonTextTertiary?: ElementObject
  buttonLinkTertiary?: ElementObject
  buttonLinkNewTabTertiary?: ElementBooleanObject
  buttonLinkTypeTertiary?: ElementObject
  linkIdButtonTertiary?: ElementObject
  linkTypeButtonTertiary?: ElementObject
  pricedropdown?: ElementObject
  appStoreImage?: string
  appStoreLink?: string
  appStoreAltText?: string
  playStoreImage?: string
  playStoreLink?: string
  playStoreAltText?: string
}

export enum ComparisonVariation {
  PRICE_DROPDOWN = 'pricedropdown',
  NO_PRICEDROPDOWN = 'nopricedropdown'
}

export interface ReactDefaultPriceProps {
  additionalNote?: any
  cardType?: string
  elements?: Elements
  index?: number
  isInEditor?: boolean
  price?: any
  priceDropdownIcon?: string
  priceDropdownIconAlt?: string
  priceTagIcon?: string
  ruleExpression?: string
  scratchPrice?: any
  term?: any
  tokenProperties?: string
  variation?: ComparisonVariation
}
